import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  COMMISSIONS_GET_RANGE_COMMISSION_MONTH_FAILURE,
  COMMISSIONS_GET_RANGE_COMMISSION_MONTH_SUCCESS
} from '../constants'

export function* getRangeCommissionSaga(action) {
  try {
      const result =  yield call(BFFAgent.Commission.getRangeCommissionMonth, action.data.rowId)
      const editRange = result?.data?.data
      
      yield put({
          type: COMMISSIONS_GET_RANGE_COMMISSION_MONTH_SUCCESS,
          data: editRange
      })
      
  } catch (error) {
    yield put({
      type: COMMISSIONS_GET_RANGE_COMMISSION_MONTH_FAILURE,
      data: { error }
    })
  }
}
